import moment from 'moment-jalaali';
import { UserStoryCard } from 'Elements';
moment.loadPersian({ dialect: 'persian-modern' });
import styles from 'partials/user-story-description.module.scss';

export const UserStoryDescription = ({ story }) => {
	return (
		<div className={styles.box}>
			<div className={styles.header}>
				<UserStoryCard user={story.user} />
				<time className={styles.time}>
					{moment(story.created_at).format('jYYYY/jMM/jDD')}
				</time>
			</div>
			<div
				className={styles.text}
				dangerouslySetInnerHTML={{
					__html: story.body
				}}
			/>
		</div>
	);
};
